(function () {
    const blocks = document.querySelectorAll<HTMLElement>('.grouped-entries-block[data-tag-filter="true"]');

    if (!blocks.length) {
        return;
    }

    blocks.forEach((block) => {
        const buttons = block.querySelectorAll<HTMLButtonElement>('.tag-filter__button');
        const allButton = block.querySelector<HTMLButtonElement>('.tag-filter__button[data-tag-all="true"]');
        const items = block.querySelectorAll<HTMLElement>('.tag-filter__item');

        if (!buttons.length || !allButton || !items.length) {
            return;
        }

        let activeTagId: string | null = null;

        const apply = () => {
            const noneActive = activeTagId === null;

            setActive(allButton, noneActive);

            buttons.forEach((btn) => {
                const id = btn.getAttribute('data-tag-id');
                if (id) {
                    setActive(btn, id === activeTagId);
                }
            });

            items.forEach((item) => {
                if (noneActive) {
                    item.classList.remove('tag-filter__item--hidden');
                    return;
                }

                const raw = item.getAttribute('data-tag-ids') || '';
                const ids = raw.split(',').map((s) => s.trim()).filter(Boolean);
                const match = ids.includes(activeTagId!);

                item.classList.toggle('tag-filter__item--hidden', !match);
            });
        };

        const setActive = (btn: HTMLButtonElement, active: boolean) => {
            btn.classList.toggle('tag-filter__button--active', active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        };

        allButton.addEventListener('click', () => {
            activeTagId = null;
            apply();
        });

        buttons.forEach((btn) => {
            const id = btn.getAttribute('data-tag-id');
            if (!id) {
                return;
            }

            btn.addEventListener('click', () => {
                activeTagId = activeTagId === id ? null : id;
                apply();
            });
        });

        apply();
    });
})();
